export default function isValidKgsTags(tags) {
  const newArr = [];
  tags?.forEach((item) => {
    if (item.kgs.length > 5) {
      newArr.push(item);
    }
  });
  return newArr.length ? newArr : [];
}
